import { graphql, useStaticQuery } from 'gatsby';
import { map, filter, includes } from 'lodash';

const getSpecificImages = ({ edges, names, key = 'fluid' }) => (
  map(filter(edges, ({ node }) => includes(names, node[key].originalName)), ({ node }) => node[key])
);

export const useImagesFluid = ({ names }) => {
  const {
    allImageSharp: { edges = [] },
  } = useStaticQuery(graphql`
    {
      allImageSharp(sort: { order: ASC, fields: fluid___originalName }) {
        edges {
          node {
            fluid(maxWidth: 1400, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
              originalName
              srcWebp
            }
          }
        }
      }
    }
  `);

  return getSpecificImages({ edges, names })
};
